import * as React from "react";
import { LanguagesMapping } from "@store";
import { Fieldset } from "../Fieldset";
import { Triangle } from "@icons";

export interface LanguageComponentProps {
    value: string | null;
    onChange: (newValue: string | null) => void;
    field: any | null;
    // Other props here
    languagesMapping: LanguagesMapping[];
}

export const LanguageComponent = (props: LanguageComponentProps) => (
    <div className="targeting-item-select-wrapper">
        <Fieldset
            label="Language"
            errorMessage={props.field}
            isMandatory={true}
            icon={Triangle}
            svgClassName="svg-triangle"
        >
            <select
                className="common-select"
                name="language"
                id=""
                value={props.value || ""}
                onChange={e => props.onChange(e.currentTarget.value)}
            >
                <option value="">Select language</option>
                {props.languagesMapping &&
                    props.languagesMapping.map((language, index) => (
                        <option key={index} value={language.isoCode}>
                            {language.name}
                        </option>
                    ))}
            </select>
        </Fieldset>
    </div>
);
